import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef } from 'react';
import { Form as Form$2 } from 'react-final-form';
import Spinner from '../MegaForm/Spinner.js';
import { FORM } from '../../utils/dataTrackingValues.js';
import Modal from '../Modal/index.js';
import Typography from '../Typography/index.js';
import DetermineFieldType from './DetermineFieldType.js';
import FormFields from './FormFields.js';
import FormSteps from './FormSteps.js';
import SubmissionMessage from './SubmissionMessage.js';
import useSteps from './useSteps.js';
import getInitialValue from './utils.js';
import { FormContainer, TCPADisclaimerContainer, FormDisclaimer, SubmitButton } from './Form.styles.js';

var _excluded = ["addressQualificationCode", "customSubmissionMessage", "disclaimer", "emilyTCPAUpdate", "fields", "formDisclaimerPosition", "formId", "formName", "formSource", "heading", "initialStepValues", "inlineButton", "isMultiStep", "onSubmit", "smartyStreetsWebsiteKey", "spanish", "steps", "submissionData", "subheading", "submitButtonColor", "submitButtonGradient", "submitButtonOutlined", "submitButtonText", "tcpaCheckbox"];
var Form = function Form(_ref) {
  var _ref$addressQualifica = _ref.addressQualificationCode,
    addressQualificationCode = _ref$addressQualifica === void 0 ? null : _ref$addressQualifica,
    _ref$customSubmission = _ref.customSubmissionMessage,
    customSubmissionMessage = _ref$customSubmission === void 0 ? null : _ref$customSubmission,
    _ref$disclaimer = _ref.disclaimer,
    disclaimer = _ref$disclaimer === void 0 ? null : _ref$disclaimer,
    _ref$emilyTCPAUpdate = _ref.emilyTCPAUpdate,
    emilyTCPAUpdate = _ref$emilyTCPAUpdate === void 0 ? function () {} : _ref$emilyTCPAUpdate,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? null : _ref$fields,
    _ref$formDisclaimerPo = _ref.formDisclaimerPosition,
    formDisclaimerPosition = _ref$formDisclaimerPo === void 0 ? 'Below Submit Button' : _ref$formDisclaimerPo,
    _ref$formId = _ref.formId,
    formId = _ref$formId === void 0 ? null : _ref$formId,
    _ref$formName = _ref.formName,
    formName = _ref$formName === void 0 ? null : _ref$formName,
    _ref$formSource = _ref.formSource,
    formSource = _ref$formSource === void 0 ? 'eloqua' : _ref$formSource,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? null : _ref$heading,
    _ref$initialStepValue = _ref.initialStepValues,
    initialStepValues = _ref$initialStepValue === void 0 ? {} : _ref$initialStepValue,
    _ref$inlineButton = _ref.inlineButton,
    inlineButton = _ref$inlineButton === void 0 ? false : _ref$inlineButton,
    _ref$isMultiStep = _ref.isMultiStep,
    isMultiStep = _ref$isMultiStep === void 0 ? false : _ref$isMultiStep,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$smartyStreetsWeb = _ref.smartyStreetsWebsiteKey,
    smartyStreetsWebsiteKey = _ref$smartyStreetsWeb === void 0 ? null : _ref$smartyStreetsWeb,
    _ref$spanish = _ref.spanish,
    spanish = _ref$spanish === void 0 ? false : _ref$spanish,
    _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? null : _ref$steps,
    _ref$submissionData = _ref.submissionData,
    submissionData = _ref$submissionData === void 0 ? {} : _ref$submissionData,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? null : _ref$subheading,
    _ref$submitButtonColo = _ref.submitButtonColor,
    submitButtonColor = _ref$submitButtonColo === void 0 ? 'primary' : _ref$submitButtonColo,
    _ref$submitButtonGrad = _ref.submitButtonGradient,
    submitButtonGradient = _ref$submitButtonGrad === void 0 ? false : _ref$submitButtonGrad,
    _ref$submitButtonOutl = _ref.submitButtonOutlined,
    submitButtonOutlined = _ref$submitButtonOutl === void 0 ? false : _ref$submitButtonOutl,
    _ref$submitButtonText = _ref.submitButtonText,
    submitButtonText = _ref$submitButtonText === void 0 ? 'Submit' : _ref$submitButtonText,
    _ref$tcpaCheckbox = _ref.tcpaCheckbox,
    tcpaCheckbox = _ref$tcpaCheckbox === void 0 ? false : _ref$tcpaCheckbox,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSubmissionMessage = _useState2[0],
    setShowSubmissionMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSubmissionErrorMessage = _useState4[0],
    setShowSubmissionErrorMessage = _useState4[1];
  var _ref2 = props || {},
    submissionUrl = _ref2.submissionUrl;
  var redirectSubmissionMessage = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h2", null, "Searching providers in your area"), /*#__PURE__*/React__default.createElement(Spinner, null));
  var _useSteps = useSteps(steps, initialStepValues, 0),
    nextStep = _useSteps.nextStep,
    currentStep = _useSteps.currentStep,
    stepValues = _useSteps.stepValues;
  var formRef = useRef(null);

  // Every form will have these fields.
  var sessionPromoCode = submissionData.sessionPromoCode,
    requestId = submissionData.requestId,
    siteURL = submissionData.siteURL,
    brandToken = submissionData.brandToken;
  var initialValues = {
    promo_code: sessionPromoCode,
    request_id: requestId,
    source: formName,
    domain: siteURL,
    brand: brandToken
  };
  if (fields) {
    fields.forEach(function (field) {
      /** We need to first check if we have default values for the brand before falling back to brandToken. */
      if (field.name === 'brand' && (field.defaultValue || field.value)) {
        initialValues.brand = field.defaultValue || field.value;
      } else if (field.name === 'landing_page' && typeof window !== 'undefined') {
        initialValues.landing_page = window.location.pathname;
      } else {
        initialValues[field.name] = getInitialValue(initialValues, field);
      }
    });
  }
  if (steps) {
    steps.forEach(function (step) {
      step.formFields.forEach(function (field) {
        initialValues[field.name] = getInitialValue(initialValues, field);
      });
    });
  }
  if (showSubmissionMessage) {
    return submissionUrl ? redirectSubmissionMessage : customSubmissionMessage || /*#__PURE__*/React__default.createElement(SubmissionMessage, {
      formId: formId
    });
  }

  /**
   * The onSubmit function needs to be asynchronous because react final form
   * uses that to know that the form is currently submitting
   * while it waits for the form submission to complete.
   * Here we combine the data we got from each step if the form is
   * multi step and combine it with the regular values.
   *
   * NOTE: Prettier and Eslint can't get along if this function is
   * created inside the `onSubmit` prop.
   */
  var finalFormOnSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, bag) {
      var locationStorage, userLocation, zipcode;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            FORM.handleClick(values, requestId);
            _context.prev = 1;
            _context.next = 4;
            return onSubmit({
              formRef: formRef.current,
              values: _objectSpread2(_objectSpread2({}, values), stepValues),
              bag: bag,
              setShowSubmissionMessage: setShowSubmissionMessage,
              setShowSubmissionErrorMessage: setShowSubmissionErrorMessage,
              smartyStreetsWebsiteKey: smartyStreetsWebsiteKey,
              addressQualificationCode: addressQualificationCode,
              tcpaCheckbox: tcpaCheckbox
            });
          case 4:
            if (submissionUrl) {
              if (typeof localStorage !== 'undefined') {
                locationStorage = localStorage.getItem('user-location');
              }
              userLocation = locationStorage ? JSON.parse(locationStorage) : null;
              zipcode = userLocation === null || userLocation === void 0 ? void 0 : userLocation.zipCode;
              setTimeout(function () {
                window.location.href = "".concat(submissionUrl, "?zip=").concat(zipcode);
              }, 2000);
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.error('Submission failed:', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function finalFormOnSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement(FormContainer, {
    className: "leshen-form",
    ref: formRef
  }, heading && /*#__PURE__*/React__default.createElement(Typography, {
    className: "heading",
    variant: "h3"
  }, heading), subheading && /*#__PURE__*/React__default.createElement(Typography, {
    className: "subheading",
    variant: "h6"
  }, subheading), /*#__PURE__*/React__default.createElement(Form$2, {
    className: "final-form",
    initialValues: initialValues,
    onSubmit: finalFormOnSubmit
  }, function (_ref4) {
    var handleSubmit = _ref4.handleSubmit,
      submitting = _ref4.submitting;
    // We create the submit button ahead of time because sometimes it has to be
    // passed to DetermineFieldType if it needs to be inline with an input, otherwise
    // we render it at the bottom of the form.
    var submitButton = /*#__PURE__*/React__default.createElement(SubmitButton, {
      className: "submit-button",
      type: "submit",
      disabled: submitting,
      color: submitButtonColor,
      outlined: submitButtonOutlined,
      gradient: submitButtonGradient
    }, submitButtonText);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Modal, {
      isShowing: showSubmissionErrorMessage,
      onClose: function onClose() {
        return setShowSubmissionErrorMessage(false);
      },
      size: "sm"
    }, /*#__PURE__*/React__default.createElement("h1", null, spanish ? 'Parece que hay un problema al enviar su formulario.' : 'Looks like there’s an issue submitting your form.'), /*#__PURE__*/React__default.createElement(Typography, null, spanish ? 'Asegúrese de que su bloqueador de anuncios esté desactivado y vuelva a intentarlo o llámenos para completar su pedido.' : 'Ensure your ad-blocker is disabled and submit again, or call us to complete your order!')), /*#__PURE__*/React__default.createElement("form", {
      noValidate: true,
      "data-testid": "Form-form",
      "data-form-type": formSource,
      onSubmit: handleSubmit,
      name: formName,
      className: "form"
    }, isMultiStep ? /*#__PURE__*/React__default.createElement(FormSteps, {
      steps: steps,
      submitButton: submitButton,
      currentStep: currentStep,
      nextStep: nextStep,
      formName: formName,
      disclaimer: disclaimer,
      tcpaCheckbox: tcpaCheckbox,
      formDisclaimerPosition: formDisclaimerPosition,
      smartyStreetsWebsiteKey: smartyStreetsWebsiteKey
    }) : /*#__PURE__*/React__default.createElement(FormFields, {
      className: formName,
      inlineButton: inlineButton,
      submitButton: submitButton,
      tcpaCheckbox: tcpaCheckbox,
      formDisclaimerPosition: formDisclaimerPosition,
      fields: fields,
      smartyStreetsWebsiteKey: smartyStreetsWebsiteKey,
      additional: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TCPADisclaimerContainer, null, tcpaCheckbox && formDisclaimerPosition === 'Above Submit Button' && /*#__PURE__*/React__default.createElement(DetermineFieldType, {
        submitButton: submitButton,
        onChange: emilyTCPAUpdate,
        formRef: formRef,
        field: {
          type: 'checkbox',
          element: 'checkbox',
          name: 'tcpa-checkbox',
          required: true,
          options: [{
            name: 'consent',
            value: 'yes',
            label: ''
          }]
        }
      }), disclaimer && formDisclaimerPosition === 'Above Submit Button' && /*#__PURE__*/React__default.createElement(FormDisclaimer, {
        disclaimer: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.brandy
      })), !inlineButton && submitButton, /*#__PURE__*/React__default.createElement(TCPADisclaimerContainer, null, tcpaCheckbox && formDisclaimerPosition !== 'Above Submit Button' && /*#__PURE__*/React__default.createElement(DetermineFieldType, {
        submitButton: submitButton,
        onChange: emilyTCPAUpdate,
        formRef: formRef,
        field: {
          type: 'checkbox',
          element: 'checkbox',
          name: 'tcpa-checkbox',
          required: true,
          options: [{
            name: 'consent',
            value: 'yes',
            label: ''
          }]
        }
      }), disclaimer && formDisclaimerPosition !== 'Above Submit Button' && /*#__PURE__*/React__default.createElement(FormDisclaimer, _extends({}, disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.brandy, {
        disclaimer: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.brandy
      }))))
    })));
  }));
};
var Form$1 = Form;

export { Form$1 as default };
//# sourceMappingURL=index.js.map
